import { useEffect, useState } from "react";

const useUpdate = (id) => {
     const [update,setUpdate]=useState({});
    useEffect(()=>{
        fetch(`https://organic-food-server.up.railway.app/foods/${id}`)
        .then(res=>res.json())
        .then(data=>setUpdate(data));
    },[]);
    return [update,setUpdate];
};

export default useUpdate;